import React from "react"

import Food from "./food"

const IndexPage = ({ location }) => <Food location={location} />

export default IndexPage
